var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('img',{staticClass:"mb-2",attrs:{"src":_vm.logoPath,"alt":"Atlas General Christmas Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }